import {FieldController} from "./elements.field.controller";
import {MoeFileItem}  from "./../../core/fileitem"


var bx = window.BX ; 

function correctBitrixUploader(){

if (bx["Uploader"]){


    if(bx.Uploader.corrected){
        return;
    }

    bx.Uploader.corrected = true; 

    bx.Uploader.prototype.mkFileInput =function(oldNode)
    {
        if (!bx(oldNode))
            return false;

            bx.unbindAll(oldNode);
        var node = oldNode.cloneNode(true);
        bx.adjust(node, {
            props : {
                value : ""
            },
            attrs: {
                name: (this.params["uploadInputName"] + '[]'),
                multiple : false, //this.params["filesInputMultiple"],
                accept : this.limits["uploadFile"],
                value : ""
        }});
        oldNode.parentNode.insertBefore(node, oldNode);
        oldNode.parentNode.removeChild(oldNode);
        return node;
    };
}
}

class inputFileCardController  extends FieldController  {

    static get $inject(){ return   [
        "$element", 
        "UniqueIdService", 
        '$scope', 
        'DialogService', 
        '$log', 
        '$sce'
    ]}

    get maxFileSize(){
        return 10 *1024*1024 
    }
    get maxCountFiles(){
        return 5;
    }

    get allowFileExtension(){
        return 'tiff,jpeg,jpg,png,pdf'
    }
    constructor(
        $element, 
        UniqueIdService, 
        $scope, 
        DialogService, 
        $log, 
        $sce
    ) {
        super($log, $scope, $element)
        correctBitrixUploader();
        this.$element = $element;
        this.scope = $scope;
        this._model = null;
        this.bxUploder = null ;
        this.componentId = 'bx_file_uplod_'+ UniqueIdService.getUniqueId();
        
		this._agentErrorHandler = bx.delegate(this._onAgentError, this);
		this._agentFileInputReinitHandler = bx.delegate(this._onAgentFileInputReinit, this);
        this._agentFileInitHandler = bx.delegate(this._onAgentFileInit, this);

        this._fileUploadStartHandler = bx.delegate(this._onFileUploadStart, this);
		this._fileUploadProgressHandler = bx.delegate(this._onFileUploadProgress, this);
		this._fileUploadCompleteHandler = bx.delegate(this._onFileUploadComplete, this);
        this._fileUploadErrorHandler = bx.delegate(this._onFileUploadError, this);
        this._fileWillBeChanged = bx.delegate(this._onFileinputWillBeChanged, this);
        

        

        this._items = [];


        this.dialogs = DialogService;
        this.__model = null;

        this.$sce = $sce; 
        this.scope.$on('errorEvent', this.onErrorEvent.bind(this));
        this.haveError=false ;
        this.errorMessage = ''; 

   

    }
    
    onErrorEvent(event, data){
        

        if(data.field.TypeFile==this.__model.TypeFile){
           
            this.haveError = true;
            this.errorMessage = data.message  ;
        }
        
    }
    get model(){
        return this.__model;
    }

    set model(value){
        this.__model = value;
        if(!!value && !this.inited){
            this.inited = true;
            this.initByModel();
        }
    }
   

    addFile(){

        correctBitrixUploader();
        if( this.getItems().length>=this.maxCountFiles){
            this.dialogs.info('Превышен максимальное количество файлов');
        }else{
            bx.fireEvent(bx(this.componentId), 'click');
        }
    }

    $onInit() {
      
        super.$onInit();
        correctBitrixUploader();
    
        if(this.model && !this.inited){
            this.inited = true;
            this.initByModel();
        }

    }

    AsHtml(html){

        return this.$sce.trustAsHtml(html);
      }

      


    initByModel(){
        if(!this.label){
            this.label=this.model.html?this.model.html:this.model.Name;

        }
       
        
        this.bxUploder = bx.Uploader.getInstance(
            {
                id: this.fileId ,
                CID:this.model.Cid,

                allowUpload: "A",
                uploadMethod: "immediate",
                uploadFileUrl: "/local/components/cript/desktop/ajax.php?mode=upload",
                deleteFileOnServer: true,
                filesInputMultiple: true,
                filesInputName: this.fileId  ,
                input: $('input', this.$element).get(0) ,
                dropZone: false,
                showImage: false,
                queueFields : {
                    thumb : {
                        tagName : "DIV",
                        className : "mobile-grid-field-file-item mobile-grid-field-file-file"
                    }
                },
                fields : {
                    thumb : {
                        tagName : "",
                        template : '#preview#',
                    },
                    preview : {
                        params : {
                            width: 212,
                            height: 119
                        }
                    }
                },
                maxSize: this.maxFileSize, 
                uploadMaxFilesize: this.maxFileSize, 

                allowUploadExt: this.allowFileExtension,
             
            }
        );
        bx.addCustomEvent(this.bxUploder, "onError", this._agentErrorHandler);
        bx.addCustomEvent(this.bxUploder, "onFileinputIsReinited", this._agentFileInputReinitHandler);
        bx.addCustomEvent(this.bxUploder, "onFileIsInited", this._agentFileInitHandler);
        bx.addCustomEvent(this.bxUploder, "onFileinputWillBeChanged", this._fileWillBeChanged);
  


        if(!!this.model && !!this.model.Files){

            this.model.Files.forEach(info => {
                

                var item =  MoeFileItem.create(info.ValueId,
                    {
                        name: bx.type.isNotEmptyString(info.Name) ? info.Name : "",
                        size:  bx.type.isNumber(parseInt(info.Size)) ? bx.UploaderUtils.getFormattedSize(parseInt(info.Size), 0): "",
                        fileId: bx.type.isNumber(parseInt(info.FileId)) ? parseInt(info.FileId): 0,
                        valueId: bx.type.isNumber(parseInt(info.ValueId)) ? parseInt(info.ValueId) : 0,
                        viewUrl: bx.type.isNotEmptyString(info.ViewUrl) ? info.ViewUrl : "",
                        deleteUrl: bx.type.isNotEmptyString(info.DeleteUrl) ? info.DeleteUrl : "",
                        progress:  0,
                        cleanSize:  bx.type.isNumber(parseInt(info.Size)) ? parseInt(info.Size): 0,
                    }
                );
        
                item.setLoaded(info.ViewUrl);
                
               
        
                //let exists =this._items.find(el=> el.fileId!=info.FileId&&el.valueId!=info.ValueId);
                //if(exists){
                // console.error('double trable');   
                //}else{
                    this._items.push(item);
                //}
            });
        }


    }


    _onAgentFileInputReinit(input)
        {
            if (input || this._agent.fileInput)
            {
                this._fileInput = input ? input : this._agent.fileInput;
            }
    }
        
    _onAgentError(/*stream, pIndex, data*/)
    {
    }

    _onAgentFileInit(id, queueItem/*, agent*/)
    {
        
        bx.addCustomEvent(queueItem, "onUploadStart", this._fileUploadStartHandler);
        bx.addCustomEvent(queueItem, 'onUploadProgress', this._fileUploadProgressHandler);
        bx.addCustomEvent(queueItem, 'onUploadDone', this._fileUploadCompleteHandler);
        bx.addCustomEvent(queueItem, 'onUploadError', this._fileUploadErrorHandler);

        bx.addCustomEvent(queueItem, "onStart", this.onStart.bind(this));
    }

    onStart(){
        debugger;
    }

    addItem(id, info)
    {
        
      
        var item = MoeFileItem.create(id,
            {
                name: bx.type.isNotEmptyString(info.name) ? info.name : "",
                size: bx.type.isNotEmptyString(info.size) ? info.size : "",
                cleanSize:  bx.type.isNumber(parseInt(info.cleanSize)) ? parseInt(info.cleanSize): 0,
                fileId: bx.type.isNumber(info.fileId) ? info.fileId : 0,
                viewUrl: bx.type.isNotEmptyString(info.viewUrl) ? info.viewUrl : "",
                progress: bx.type.isNumber(info.progress) ? info.progress : 0
            }
        );

        
       

        this._items.push(item);
        this.haveError= false;
        this.redraw();
        return item;
    }
    
    
    _onFileinputWillBeChanged(fileInput){
        
        const sizes = this.getItems().map(el=>el.getSetting('cleanSize'));
        let uploadSize = (sizes.length>0?sizes.reduce((accumulator, currentValue) => accumulator + currentValue):0) 
        
        for (var i = 0; i < fileInput.target.files.length; i++) {
            const file = fileInput.target.files.item(i);
            uploadSize+=file.size
        }
        

        if(uploadSize>this.maxFileSize){
            fileInput.target.value = ''
            this.dialogs.info('Превышен максимальный размер файла');
            throw 'Превышен максимальный размер';
        }


    }

    _onFileUploadStart (queueItem, percent/*, agent, pIndex*/)
    {
   

        const sizes = this.getItems().map(el=>el.getSetting('cleanSize'));
        const uploadSize = (sizes.length>0?sizes.reduce((accumulator, currentValue) => accumulator + currentValue):0) + ( bx.type.isNumber(parseInt(queueItem.file.size)) ? parseInt(queueItem.file.size): 0)
        if(uploadSize>this.maxFileSize){
            debugger
            this.dialogs.info('Превышен максимальный размер файла');
           // throw 'Превышен максимальный размер';
        }

        if( this.getItems().length>=this.maxCountFiles){
            throw 'Превышен максимальное колличество ';
        }
        
        /*var item = */this.addItem(queueItem.id,
            {
                name: queueItem.name,
                size: queueItem.size,
                fileId: 0,
                progress: parseInt(percent),
                cleanSize:  bx.type.isNumber(parseInt(queueItem.file.size)) ? parseInt(queueItem.file.size): 0,
            }
        );
        this.redraw();
       // item.layout();
    }

    _onFileUploadProgress(queueItem, percent/*, agent, pIndex*/)
    {
        var item = this.getItem(queueItem.id);
        if (item)
        {
            if (percent >= 100)
                percent = 99;
            item.setProgress(percent);
        }
        this.redraw();
    }

    removeItem (item)
    {

        //var item = this.getItem(item.id);


        this.dialogs
        .confirm('Удаление Файла','Операция не поддерживает восстановление, Удалить?')
            .then(bx.delegate(function(){

                for (var i = 0; i < this._items.length; i++)
                {
                    if (this._items[i] === item)
                    {
                    
                        this._items.splice(i, 1);
                        break;
                    }
                }
        
                for ( i = 0; i < this.model.Files.length; i++)
                {
                    if (this.model.Files[i].FileId == item.getFileId())
                    {

                        if(this.model.Files[i].DeleteUrl){
                            bx.ajax.get(this.model.Files[i].DeleteUrl);
                        }
                        this.model.Files.splice(i, 1);
                        break;
                    }
                }
        
                this.redraw();

               
                }, 
                this)
            );
        
        


      
    }

    removeAllItems()
    {
       
        this._items = [];

        this.model.Files = [];
        this.redraw();
    }
    
    _onFileUploadComplete (queueItem, params/*, agent, pIndex*/)
    {

        var item = this.getItem(queueItem.id);
        
        
        if (!item)
        {
            return;
        }

        item.setProgress(100);

        bx.removeCustomEvent(queueItem, "onUploadStart", this._fileUploadStartHandler);
        bx.removeCustomEvent(queueItem, "onUploadProgress", this._fileUploadProgressHandler);
        bx.removeCustomEvent(queueItem, "onUploadDone", this._fileUploadCompleteHandler);
        bx.removeCustomEvent(queueItem, "onUploadError", this._fileUploadErrorHandler);

        var fileId = 0;
        if (typeof(params.file) !== "undefined")
        {
            if (typeof(params.file["file_id"]) !== "undefined")
            {
                fileId = parseInt(params.file["file_id"]);
            }
            else if (typeof(params.file["originalId"]) !== "undefined")
            {
                fileId = parseInt(params.file["originalId"]);
            }
        }

        if (fileId > 0)
        {
            item.setFileId(fileId);
        }
        item.setLoaded(params.file.url);
        

 
        this.model.Files.push( {
            Name: params.file.name, 
            Size: params.file.size, 
            FileId:params.file.file_id,  
            ViewUrl:params.file.url
        })
        this.haveError= false;
        this.redraw();
       // this.showLabel(true);
    }

    _onFileUploadError (queueItem, params, agent, pIndex)
    {
        var item = this.getItem(queueItem.id);

        this.error('unable upload file ',[queueItem, params, agent, pIndex]);

        
        const msgError = params.error?params.error:'Произошла ошибка при загрузке файла';
        this.dialogs.info(msgError);

        if (item)
        {
            
            //this.removeItem(item);

            for (var i = 0; i < this._items.length; i++)
            {
                if (this._items[i] === item)
                {
                
                    this._items.splice(i, 1);
                    break;
                }
            }
            
            item = this.bxUploder.queue.items.getItem(item.getId());
            if (item)
            {
                item.deleteFile();
            }
        
           
                
        }

        
        bx.removeCustomEvent(queueItem, "onUploadStart", this._fileUploadStartHandler);
        bx.removeCustomEvent(queueItem, "onUploadProgress", this._fileUploadProgressHandler);
        bx.removeCustomEvent(queueItem, "onUploadDone", this._fileUploadCompleteHandler);
        bx.removeCustomEvent(queueItem, "onUploadError", this._fileUploadErrorHandler);

        this.redraw();
    }

    getItems()
    {

        
        return this._items;
    }
    getItem(id)
    {
        for (var i = 0; i < this._items.length; i++)
        {
            var item = this._items[i];
            if (item.getId() === id)
            {
                return item;
            }
        }
        return null;
    }
    hasItems()
    {
        return this._items.length > 0;
    }



    $postLink (){
        super.$postLink();
/*
        
        this.inputFile = bx.findChild(bx(this.$element.get(0)), {
                    "tag" : "input",
                }, 
                true,
                false
            );

        */
       
        
    }

}


class inputFileOneController extends  inputFileCardController {
    get maxFileSize(){
        return 10 *1024*1024 
    }
    get maxCountFiles(){
        return 1;
    }

    get allowFileExtension(){
        return 'pkcs7,sig'
    }
    _onFileUploadComplete (queueItem, params/*, agent, pIndex*/){

        debugger
        super._onFileUploadComplete (queueItem, params/*, agent, pIndex*/);
        
        var item = this.getItem(queueItem.id);
        
        
        if (!item)
        {
            return;
        }


        this.onUploadComplete();
    }
    
}
export {
    inputFileCardController,
    inputFileOneController
}




// WEBPACK FOOTER //
// ./src/components/elements/elements.file.card.module.js